import { useState } from "react";

const initialsFrom = (name) => {
    const trimmed = (name || "").trim();
    return trimmed ? trimmed.charAt(0).toUpperCase() : "?";
};

const MerchantLogo = ({
    merchantLogo,
    merchantName,
    className = "w-100",
    fallbackClassName = "fs-2",
}) => {
    const [broken, setBroken] = useState(false);

    const hasLogo =
        merchantLogo && merchantLogo !== "pending-upload" && !broken;

    if (hasLogo) {
        return (
            <img
                src={process.env.REACT_APP_API_PUBLIC_URL + merchantLogo}
                alt={merchantName || "Merchant logo"}
                className={className}
                onError={() => setBroken(true)}
            />
        );
    }

    return (
        <div
            className={`w-100 h-100 d-flex align-items-center justify-content-center bg-light-primary text-primary fw-bold ${fallbackClassName}`}
        >
            {initialsFrom(merchantName)}
        </div>
    );
};

export default MerchantLogo;